export const CREATE_CHANGE_ORDER = "CREATE_CHANGE_ORDER";
export const CREATE_CHANGE_ORDER_SUCCESS = "CREATE_CHANGE_ORDER_SUCCESS";
export const CREATE_CHANGE_ORDER_ERROR = "CREATE_CHANGE_ORDER_ERROR";

export const CHANGE_ORDER_GET_ALL = "CHANGE_ORDER_GET_ALL";
export const CHANGE_ORDER_GET_ALL_SUCCESS = "CHANGE_ORDER_GET_ALL_SUCCESS";
export const CHANGE_ORDER_GET_ALL_ERROR = "CHANGE_ORDER_GET_ALL_ERROR";

export const CHANGE_ORDER_GET_BY_ID = "CHANGE_ORDER_GET_BY_ID";
export const CHANGE_ORDER_GET_BY_ID_SUCCESS = "CHANGE_ORDER_GET_BY_ID_SUCCESS";
export const CHANGE_ORDER_GET_BY_ID_ERROR = "CHANGE_ORDER_GET_BY_ID_ERROR";

export const CHANGE_ORDER_LOADING = "CHANGE_ORDER_LOADING";

export const CLEAR_CHANGE_ORDER_DATA = "CLEAR_CHANGE_ORDER_DATA";

export const CHANGE_ORDER_STATUS_GET_ALL = "CHANGE_ORDER_STATUS_GET_ALL";
export const CHANGE_ORDER_STATUS_GET_ALL_SUCCESS =
  "CHANGE_ORDER_STATUS_GET_ALL_SUCCESS";
export const CHANGE_ORDER_STATUS_GET_ALL_ERROR =
  "CHANGE_ORDER_STATUS_GET_ALL_ERROR";

export const CHANGE_ORDER_DELETE = "CHANGE_ORDER_DELETE";
export const CHANGE_ORDER_DELETE_SUCCESS = "CHANGE_ORDER_DELETE_SUCCESS";
export const CHANGE_ORDER_DELETE_ERROR = "CHANGE_ORDER_DELETE_ERROR";

export const UPDATE_CHANGE_ORDER_STATUS = "UPDATE_CHANGE_ORDER_STATUS";
export const UPDATE_CHANGE_ORDER_STATUS_SUCCESS =
  "UPDATE_CHANGE_ORDER_STATUS_SUCCESS";
export const UPDATE_CHANGE_ORDER_STATUS_ERROR =
  "UPDATE_CHANGE_ORDER_STATUS_ERROR";
